module.exports = __webpack_public_path__ + "static/cause-1-4-c11490b0055731a74cf40e383405185e.jpg";